import { createSelector } from '@reduxjs/toolkit';

import { ApplicationState } from 'types/store';

const selectState = ({ audience: { shared } }: ApplicationState) => shared;

export const selectAudienceConversionStatus = createSelector(selectState, ({ conversionStatus }) => conversionStatus);

export const selectAudienceDataSourceType = createSelector(selectState, ({ dataSourceType }) => dataSourceType);

export const selectAudienceDefaultFieldValues = createSelector(
  selectState,
  ({ defaultFieldValues }) => defaultFieldValues
);

export const selectAudienceFieldValues = createSelector(selectState, ({ fieldValues }) => fieldValues);

export const selectAudienceFilterType = createSelector(selectState, ({ filterType }) => filterType);

export const selectAudienceIsMultiRfm = createSelector(selectState, ({ isMultiRfm }) => isMultiRfm);

export const selectAudienceMultiRfmActive = createSelector(selectState, ({ multiRfmGroups, multiRfmIndex }) => {
  return multiRfmGroups[multiRfmIndex ?? 0];
});

export const selectAudienceMultiRfmGroups = createSelector(selectState, ({ multiRfmGroups }) => multiRfmGroups);

export const selectAudienceMultiRfmIndex = createSelector(selectState, ({ multiRfmIndex }) => multiRfmIndex);

export const selectAudienceMultiRfmOperation = createSelector(
  selectState,
  ({ multiRfmOperation }) => multiRfmOperation
);

export const selectAudiencePreviousFieldValues = createSelector(
  selectState,
  ({ previousFieldValues }) => previousFieldValues
);

export const selectAudienceRecencyType = createSelector(selectState, ({ recencyType }) => recencyType);

export const selectAudienceSearchType = createSelector(selectState, ({ searchType }) => searchType);

export const selectAudienceSelectedCategory = createSelector(selectState, ({ selectedCategory }) => selectedCategory);

export const selectAudienceSelectedSearch = createSelector(selectState, ({ selectedSearch }) => selectedSearch);

export const selectHasSearchTypeChanged = createSelector(
  selectState,
  ({ previousSearchType, searchType }) => previousSearchType !== searchType
);

export const selectUsedDataPoints = createSelector(selectState, ({ usedDataPoints }) => usedDataPoints);

export const selectUsedDataPointsAnd = createSelector(selectUsedDataPoints, ({ and }) => and);

export const selectUsedDataPointsOr = createSelector(selectUsedDataPoints, ({ or }) => or);
